import { useEffect } from "react";
function AnimatorLoginPage(props) {
    useEffect(() => {
        // Check if already authenticated via BFF session cookie
        fetch("/auth/me", { credentials: "include" })
            .then((res) => {
            if (!res.ok)
                throw new Error("Not authenticated");
            return res.json();
        })
            .then((user) => {
            var _a, _b;
            // Already logged in — pass user info up
            props.onLogin(user.sub, (_b = (_a = user.name) !== null && _a !== void 0 ? _a : user.preferred_username) !== null && _b !== void 0 ? _b : "");
        })
            .catch(() => {
            // Not authenticated — redirect to Keycloak via BFF
            const returnTo = window.location.pathname + window.location.search;
            window.location.href = `/auth/login?returnTo=${encodeURIComponent(returnTo)}`;
        });
    }, []);
    return null;
}
export default AnimatorLoginPage;
